import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App.js';
import 'font-awesome/css/font-awesome.min.css';
import Config from './commons/config/Config.js';

function renderApp(locale, messages) {
    ReactDOM.render(<App locale={locale} messages={messages} />, document.getElementById("root"));
}

function bootstrapApp(configData) {
    localStorage.setItem('config', JSON.stringify(configData));
    var defaultLocale = Config.get('defaultLanguage') || 'es';
    var locale = localStorage.getItem('userLocale') || defaultLocale;
    localStorage.setItem('userLocale', locale);

    fetch('https://flow.vecfleet.io/api/lang/' + locale, {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    })
    .then(function(response) { return response.json(); })
    .then(function(data) { renderApp(locale, JSON.parse(JSON.stringify(data))); })
    .catch(function() { renderApp(locale, {}); });
}

fetch('/config/config.json', {
    method: 'GET',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
})
.then(function(response) { return response.json(); })
.then(function(configData) { bootstrapApp(configData); })
.catch(function() {
    try {
        var cached = JSON.parse(localStorage.getItem('config'));
        if (cached) { bootstrapApp(cached); return; }
    } catch(e) {}
    renderApp('es', {});
});
